<template>
  <div>
    <v-btn bottom
           color="#26c6da"

           dark
           fab
           fixed
           right
           @click="dialog = !dialog">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog
        v-model="dialog"
        width="800px">
      <v-card light>
        <v-card-title class=" darken-2">
          Nuevo proyecto
        </v-card-title>
        <v-container>
          <v-row align="center"
                 justify="center">
            <v-col cols="12" md="4">
              <v-select
                  v-model="user"
                  :items="users"
                  label="Cliente"/>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field type="text" label="nombre del proyecto" v-model="name"/>
            </v-col>
            <v-col cols="12" md="3" style="display: inline-flex;">
              <v-btn                 color="#26c6da"
                                     dark v-on:click="saveZone">Guardar</v-btn>
              <v-btn class="ml-2" outlined style="margin: 0 auto;" text @click="dialog = false">Cerrar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "newproject",
  props:['refresh'],
  data: () => ({
    dialog: false,
    users: [],
    user:1,
    name:''
  }),
  mounted() {
    this.getClients()
  },
  methods: {
    getClients(){
      let url = this.base_url + '/invV2/admin/clientes/' + localStorage.token;
      this.axios.get(url).then(response => {
        response.data.clients.forEach(user => {
          this.users.push({text: user.socialName, value: user.userID})
        })
      });
    },
    saveZone() {
      let formData = new FormData();
      formData.set('uid', this.user);
      formData.set('name', this.name);
      formData.set('token', localStorage.token);
      let url = this.base_url + "/invV2/admin/nuevoproyecto/";
      this.axios.post(url, formData).then(() => {
        this.dialog = false;
        this.refresh();
      });
    }
  }
}
</script>

<style scoped>

</style>
